import "../chunk-7B52C2XE.js";
import axios from "axios";
function initClient(baseURL, useAdapter) {
  const client = axios.create({ baseURL });
  if (useAdapter) {
    client.defaults.adapter = function(config) {
      return fetch(config.baseURL + config.url, {
        method: config.method,
        headers: config.headers,
        body: config.data,
        credentials: config.withCredentials ? "include" : void 0
      }).then(
        (response) => response.text().then((text) => ({
          data: text,
          status: response.status,
          statusText: response.statusText,
          headers: response.headers,
          config,
          request: fetch
        }))
      ).catch(function(reason) {
        throw reason;
      });
    };
  }
  return client;
}
export {
  initClient
};
